
export const DESIGN_PRESETS = {

    "abstract-001": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/abstract-001.png",
        themeAturCaraColour: "#7e88a1ff",
        themeBaseCardColour: "#faf5f2",
        themeColour: "#67728fff",
    },

    "abstract-002": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/abstract-002.png",
        themeAturCaraColour: "#f1c18dff",
        themeBaseCardColour: "#fbf7f6",
        themeColour: "#e2b482",
    },


    "floral-001": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-001.png",
        themeAturCaraColour: "#DD9292",
        themeBaseCardColour: "#fff9f1",
        themeColour: "#ba6059",
    },


    "floral-002": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-002.png",
        themeAturCaraColour: "#cebf95ff",
        themeBaseCardColour: "#fff9f1",
        themeColour: "#ad9960ff",
    },

    "floral-003": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-003.png",
        themeAturCaraColour: "#c4a07c",
        themeBaseCardColour: "#fff9f1",
        themeColour: "#ac8a68",
    },

    "floral-004": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-004.png",
        themeAturCaraColour: "#b56276",
        themeBaseCardColour: "#f5f3f4",
        themeColour: "#b64a62",
    },

    "floral-005": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-005.png",
        themeAturCaraColour: "#a18d78",
        themeBaseCardColour: "#fcf4ef",
        themeColour: "#806f5d",
    },

    "floral-006": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-006.png",
        themeAturCaraColour: "#8d789bff",
        themeBaseCardColour: "#faf7f0",
        themeColour: "#685474ff",
    },

    "floral-007": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-007.png",
        themeAturCaraColour: "#c7846fff",
        themeBaseCardColour: "#363634",
        themeColour: "#dd9580",
    },

    "floral-008": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-008.png",
        themeAturCaraColour: "#3b4e75ff",
        themeBaseCardColour: "#fef4ea",
        themeColour: "#3e537cff",
    },

    "floral-009": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-009.png",
        themeAturCaraColour: "#b3c19d",
        themeBaseCardColour: "#f9f9f1",
        themeColour: "#8fa16fff",
    },

    "floral-010": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-010.png",
        themeAturCaraColour: "#a7b5c7ff",
        themeBaseCardColour: "#f1f2f4",
        themeColour: "#7682a3",
    },

    "floral-011": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-011.png",
        themeAturCaraColour: "#c9c4a4ff",
        themeBaseCardColour: "#f9f8f4",
        themeColour: "#b6b08cff",
    },

    "floral-012": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-012.png",
        themeAturCaraColour: "#8298b1ff",
        themeBaseCardColour: "#f1f2f4",
        themeColour: "#65788d",
    },

    "floral-013": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-013.png",
        themeAturCaraColour: "#bb9c60",
        themeBaseCardColour: "#f3f2ed",
        themeColour: "#b89551",
    },

    "floral-014": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-014.png",
        themeAturCaraColour: "#ef9390",
        themeBaseCardColour: "#faf5f1",
        themeColour: "#ef9390",
    },

    "floral-015": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-015.png",
        themeAturCaraColour: "#862438ff",
        themeBaseCardColour: "#f7f2ee",
        themeColour: "#a1344a",
    },

    "floral-016": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-016.png",
        themeAturCaraColour: "#8A8B77",
        themeBaseCardColour: "#f3eee8",
        themeColour: "#8A8B77",
    },

    "floral-017": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-017.png",
        themeAturCaraColour: "#6E7D94",
        themeBaseCardColour: "#fafafa",
        themeColour: "#6E7D94",
    },

    "floral-018": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-018.png",
        themeAturCaraColour: "#A05A8C",
        themeBaseCardColour: "#fbecf1",
        themeColour: "#A05A8C",
    },

    "floral-019": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-019.png",
        themeAturCaraColour: "#587A65",
        themeBaseCardColour: "#edf0e9",
        themeColour: "#587A65",
    },

    "floral-020": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-020.png",
        themeAturCaraColour: "#B08D57",
        themeBaseCardColour: "#fcf6ea",
        themeColour: "#B08D57",
    },

    "floral-021": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-021.png",
        themeAturCaraColour: "#5d6623",
        themeBaseCardColour: "#f2ede7",
        themeColour: "#893941",
    },

    "floral-022": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-022.png",
        themeAturCaraColour: "#6B5A46",
        themeBaseCardColour: "#f8f1eb",
        themeColour: "#6B5A46",
    },

    "floral-023": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-023.png",
        themeAturCaraColour: "#032046ff",
        themeBaseCardColour: "#fdefee",
        themeColour: "#032046ff",
    },

    "floral-024": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-024.png",
        themeAturCaraColour: "#8E82C9",
        themeBaseCardColour: "#fef9f3",
        themeColour: "#8E82C9",
    },

    "floral-025": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-025.png",
        themeAturCaraColour: "#520000ff",
        themeBaseCardColour: "#efded4",
        themeColour: "#752435",
    },

    "floral-026": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-026.png",
        themeAturCaraColour: "#5d6623",
        themeBaseCardColour: "#f3eeea",
        themeColour: "#752435",
    },

    "floral-027": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-027.png",
        themeAturCaraColour: "#66123dff",
        themeBaseCardColour: "#f4dde7",
        themeColour: "#7B2625",
    },

    "floral-028": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-028.png",
        themeAturCaraColour: "#8B2E5D",
        themeBaseCardColour: "#fdf0ea",
        themeColour: "#793459",
    },

    "floral-029": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-029.png",
        themeAturCaraColour: "#23402D",
        themeBaseCardColour: "#e4ddca",
        themeColour: "#23402D",
    },

    "floral-030": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-030.png",
        themeAturCaraColour: "#7B7550",
        themeBaseCardColour: "#f4ece1",
        themeColour: "#7B7550",
    },

    "floral-031": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-031.png",
        themeAturCaraColour: "#b8605f",
        themeBaseCardColour: "#f9eee8",
        themeColour: "#cf6361ff",
    },

    "floral-032": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-032.png",
        themeAturCaraColour: "#551F32",
        themeBaseCardColour: "#e3e6ed",
        themeColour: "#551F32",
    },

    "floral-033": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-033.png",
        themeAturCaraColour: "#5A4058",
        themeBaseCardColour: "#eee5de",
        themeColour: "#5A4058",
    },

    "floral-034": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-034.png",
        themeAturCaraColour: "#5A4058",
        themeBaseCardColour: "#fdd1cd3d",
        themeColour: "#5A4058",
    },

    "floral-035": {
        fontNamingOpenCardStyle: "Molle",
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/floral-035.png",
        themeAturCaraColour: "#743639",
        themeBaseCardColour: "#F5F0E6",
        themeColour: "#5c5835",
        // buttonColour: "#602c2e",
        // countDayColour: "#602c2e",
        // labelCountDayColour: "#fafafaff",
        // textWishColour: "#ffffff",
    },



    "kdrama-001": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/kdrama-001.png",
        themeAturCaraColour: "#929b6b",
        themeBaseCardColour: "#fdf9ed",
        themeColour: "#929b6b",
    },

    "kdrama-002": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/kdrama-002.png",
        themeAturCaraColour: "#f1b8b7ff",
        themeBaseCardColour: "#fff5efff",
        themeColour: "#d48f8eff",
    },

    "kdrama-003": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/kdrama-003.png",
        themeAturCaraColour: "#c09a75ff",
        themeBaseCardColour: "#fff5efff",
        themeColour: "#b6916cff",
    },


    "kdrama-004": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/kdrama-004.png",
        themeAturCaraColour: "#f1b8b7ff",
        themeBaseCardColour: "#fff5efff",
        themeColour: "#d48f8eff",
    },

    "kdrama-005": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/kdrama-005.png",
        themeAturCaraColour: "#839dbbff",
        themeBaseCardColour: "#fff5efff",
        themeColour: "#6d8db3ff",
    },

    "kdrama-006": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/kdrama-006.png",
        themeAturCaraColour: "#839dbbff",
        themeBaseCardColour: "#fff5efff",
        themeColour: "#6d8db3ff",
    },

    "kdrama-007": {
        designTemplate: "modern",
        fontBrideStyle: "Great Vibes",
        fontNamingStyle: "Dancing Script",
        cardBackground: "/card-backgrounds/kdrama-007.png",
        themeAturCaraColour: "#6F786F",
        themeBaseCardColour: "#f7efea",
        themeColour: "#6F786F",
    },

    "klasik-001": {
        designTemplate: "classic",
        fontBrideStyle: "Khodijah Free",
        fontNamingStyle: "Khodijah Free",
        cardBackground: "/card-backgrounds/klasik-001.png",
        themeColour: "#613813",
    },

    "klasik-002": {
        designTemplate: "classic",
        fontBrideStyle: "Khodijah Free",
        fontNamingStyle: "Khodijah Free",
        cardBackground: "/card-backgrounds/klasik-002.png",
        themeColour: "#613813",
    },


};
